import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import Menu from './Menu/Container'
import AdminMenu from './AdminMenu/Container'
import '../../css/App.css';
import '../../css/fonts.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';

class Layout extends Component {

    componentDidMount(){

    }

    
    render() {



	return (
	    <div className="container-fluid">
	
		<Menu />
		<AdminMenu />
		{this.props.children}
		<footer>
		    <div className="logo"><Link to="/"><img src="/logo-white.png" alt="logo"  /></Link></div>
		    <div> Ul./Via Donizetti, 3 34133 - Trst/Trieste</div>
		</footer>
	    </div>
	);
    }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/index.jsx